import Cookies from 'js-cookie';
import { gsap } from 'gsap/dist/gsap';
import Observer from '../classes/Observer';

class Announcement extends Observer {
  constructor(el, wWidth) {
    super({
      isOnce: false,
    });
    this.$el = $(el);
    this.$inner = this.$el.find('.announcement__inner');
    this.isSingle = this.$el.hasClass('announcement--restaurant');
    this.$observable = $('.announcement-observable');
    this.$body = $('body');
    this.wWidth = wWidth;
    this.maxAttempts = 4;
    this.currentAttempt = 0;
    this.delayTimer = 3000;
    this.shouldBeShown = false;
    this.isCookieViewed = false;
    this.isVisible = false;
    this.tween = null;

    this.init();
  }

  init() {
    this.isGeneralShown = window.sessionStorage.getItem('announcement-shown');
    if ((!this.isGeneralShown && !this.isSingle) || this.isSingle) {
      this.shouldBeShown = true;
    }

    if (this.shouldBeShown) {
      this.interval = setInterval(this.tryToShow.bind(this), this.delayTimer);

      // mobile marquee animation
      this.mm = gsap.matchMedia();
      this.mm.add('(max-width: 1023px)', () => {
        this.tween = gsap.to(this.$inner, {
          repeat: -1,
          x: '-50%',
          duration: this.$inner.width() / 100,
          ease: 'none',
          delay: 1,
          paused: !this.isVisible,
        });

        return () => {
          this.tween = null;
        };
      });

      this.observer.observe(this.$observable.get(0));
      this.tryToShow();
    }
  }

  tryToShow() {
    this.currentAttempt += 1;
    this.checkCookies();

    if (this.currentAttempt >= this.maxAttempts || this.isCookieViewed) {
      clearInterval(this.interval);
      this.showAnnouncement();
      if (this.tween) {
        this.tween.play();
      }
    }
  }

  checkCookies() {
    const cookie = Cookies.get('cookieyes-consent');

    // if cookie is not set, show the announcement
    if (!cookie) {
      this.isCookieViewed = true;
      return;
    }

    // parse a:b,c:d,e:f to {a: b, c: d, e: f}
    const cookieParsed = cookie.split(',').reduce((acc, curr) => {
      const [key, value] = curr.split(':');
      acc[key] = value;
      return acc;
    }, {});

    if (cookieParsed.action === 'yes') {
      this.isCookieViewed = true;
    }
  }

  showAnnouncement() {
    this.isVisible = true;
    this.$el.addClass('is-visible');
    $('body').addClass('is-announcement');
    window.sessionStorage.setItem('announcement-shown', true);
  }

  animateIn() {
    this.$body.addClass('is-page-start');
    if (this.tween) {
      this.tween.play();
    }
  }

  animateOut() {
    this.$body.removeClass('is-page-start');
    if (this.tween) {
      this.tween.pause();
    }
  }

  onResize(wWidth) {
    this.wWidth = wWidth;
  }
}

export default Announcement;
